export default __webpack_public_path__ + "static/media/Madfang.24f6374a.jpg";